/**
  ---DO NOT EDIT THIS FILE DIRECTLY---
  This CSS file was concatenated from files listed in the css/ folder as part of a build process
  This is to allow for js import with @import links which will not be followed
**/

/* src/primitives/menu/css/definition/content/menu.css */
@layer menu.definition.content.menu {
  :host(ui-menu) {
    display: block;
    margin: var(--menu-margin);
    padding: var(--menu-padding);
    box-shadow: var(--menu-box-shadow);
    border: var(--menu-border);
    font-size: var(--menu-font-size);
  }
  .menu {
    display: flex;
    flex-direction: row;
    font-weight: var(--menu-font-weight);
    gap: var(--menu-gap);
    background: var(--menu-background);
    align-items: var(--menu-align-items);
    justify-content: var(--menu-justify-content);
  }
  .menu.icon-only .label {
    display: none;
  }
  .menu.icon-only ui-icon {
    margin: 0 !important;
  }
}

/* src/primitives/menu/css/definition/content/menu-item.css */
@layer menu.definition.content.menuItem {
  .item {
    display: block;
    cursor: pointer;
    background: var(--menu-item-background);
    margin: var(--menu-item-margin);
    padding: var(--menu-item-padding);
    border: var(--menu-item-border);
    color: var(--menu-item-color);
    font-weight: var(--menu-item-font-weight);
    line-height: var(--menu-item-line-height);
    box-shadow: var(--menu-item-box-shadow);
    border-radius: var(--menu-item-border-radius);
    text-align: var(--menu-item-text-align);
    text-decoration: var(--menu-item-text-decoration);
  }
  .item:hover,
  .item.hover {
    background: var(--menu-item-hover-background);
    margin: var(--menu-item-hover-margin);
    padding: var(--menu-item-hover-padding);
    border: var(--menu-item-hover-border);
    color: var(--menu-item-hover-color);
    box-shadow: var(--menu-item-hover-box-shadow);
    border-radius: var(--menu-item-hover-border-radius);
  }
  .active.item {
    cursor: default;
    background: var(--menu-item-active-background);
    margin: var(--menu-item-active-margin);
    padding: var(--menu-item-active-padding);
    border: var(--menu-item-active-border);
    box-shadow: var(--menu-item-active-box-shadow);
    font-weight: var(--menu-item-active-font-weight);
    color: var(--menu-item-active-color);
    border-radius: var(--menu-item-active-border-radius);
  }
}

/* src/primitives/menu/css/definition/content/icon.css */
@layer menu.definition.content.icon {
  .menu ui-icon {
    margin-right: var(--menu-icon-margin);
  }
  .menu ui-icon:only-child {
    margin-right: 0;
  }
}

/* src/primitives/menu/css/definition/content/badge.css */
@layer menu.definition.content.badge {
  .menu ui-label[badge] {
    margin-left: var(--menu-badge-margin);
  }
}

/* src/primitives/menu/css/definition/types/selection.css */
@layer menu.definition.types.selection {
  .selection.menu {
    gap: var(--menu-selection-gap);
  }
  .selection.menu ::slotted(*),
  .selection.menu menu-item {
    --menu-item-padding: var(--menu-selection-item-padding);
    --menu-item-border-radius: var(--menu-selection-item-border-radius);
    --menu-item-color: var(--menu-selection-item-color);
    --menu-item-hover-background: var(--menu-selection-item-hover-background);
    --menu-item-hover-border-radius: var(--menu-selection-item-border-radius);
    --menu-item-hover-color: var(--menu-selection-item-hover-color);
    --menu-item-hover-box-shadow: var(--menu-selection-item-hover-box-shadow);
    --menu-item-active-background: var(--menu-selection-item-active-background);
    --menu-item-active-border-radius: var(--menu-selection-item-border-radius);
    --menu-item-active-padding: var(--menu-selection-item-active-padding);
    --menu-item-active-color: var(--menu-selection-item-active-color);
    --menu-item-active-box-shadow: var(--menu-selection-item-active-box-shadow);
  }
}

/* src/primitives/menu/css/definition/types/sliding.css */
@layer menu.definition.types.sliding {
  .sliding.menu {
    position: relative;
    gap: var(--menu-sliding-gap);
    padding: var(--menu-sliding-padding);
    border-radius: var(--menu-sliding-border-radius);
    background: var(--menu-sliding-background);
    border: var(--menu-sliding-border);
  }
  .sliding.menu ::slotted(*),
  .sliding.menu menu-item {
    --menu-item-padding: var(--menu-sliding-item-padding);
    --menu-item-color: var(--menu-sliding-item-color);
    --menu-item-hover-color: var(--menu-sliding-item-hover-color);
    --menu-item-hover-background: transparent;
    --menu-item-active-background: transparent;
    --menu-item-active-color: var(--menu-sliding-item-active-color);
    --menu-item-active-font-weight: var(--bold);
    position: relative;
    z-index: 1;
  }
  .sliding.menu .indicator {
    position: absolute;
    top: var(--menu-sliding-padding);
    bottom: var(--menu-sliding-padding);
    background: var(--menu-sliding-indicator-background);
    border-radius: var(--menu-sliding-indicator-border-radius);
    box-shadow: var(--menu-sliding-indicator-shadow);
    transition: var(--menu-sliding-indicator-transition);
    z-index: 0;
  }
}

/* src/primitives/menu/css/definition/variations/evenly-spaced.css */
@layer menu.definition.variations.equalWidth {
  .evenly-spaced.menu {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: minmax(0, 1fr);
    --menu-item-text-align: var(--menu-evenly-spaced-item-text-align) ;
  }
}

/* src/primitives/menu/css/definition/variations/fitted.css */
@layer menu.definition.variations.fitted {
  :host([fitted]),
  .fitted.menu {
    margin: 0;
  }
}

/* src/primitives/menu/css/definition/variations/inset.css */
@layer menu.definition.variations.inset {
  .inset.menu {
    border: var(--menu-inset-border);
    border-radius: var(--menu-inset-border-radius);
    padding: var(--menu-inset-padding);
    background: var(--menu-inset-background);
  }
}

/* src/primitives/menu/css/definition/variations/vertical.css */
@layer menu.definition.variations.vertical {
  .vertical.menu {
    flex-direction: column;
    align-items: var(--menu-vertical-align-items);
    text-align: var(--menu-vertical-text-align);
  }
}

/* src/primitives/menu/css/definition/menu-definition.css */

/* src/primitives/menu/css/theme/content/menu-variables.css */
@layer menu.theme.content.menu {
  :host {
    --menu-margin: var(--vertically-spaced);
    --menu-font-weight: var(--normal);
    --menu-gap: var(--4px);
    --menu-align-items: flex-start;
    --menu-font-size: var(--medium);
    --menu-justify-content: flex-start;
    --menu-padding: 0;
    --menu-box-shadow: none;
    --menu-background: none;
    --menu-border: none;
  }
}

/* src/primitives/menu/css/theme/content/menu-item-variables.css */
@layer menu.theme.content.menuItem {
  :host {
    --menu-item-background-color: transparent;
    --menu-item-background-image: none;
    --menu-item-background: var(--menu-item-background-color) var(--menu-item-background-image);
    --menu-item-margin: 0;
    --menu-item-line-height: 1;
    --menu-item-font-weight: var(--bold);
    --menu-item-padding: var(--7px) var(--6px);
    --menu-item-border: none;
    --menu-item-border-radius: none;
    --menu-item-color: var(--standard-20);
    --menu-item-text-align: inherit;
    --menu-item-box-shadow: none;
    --menu-item-text-decoration: none;
    --menu-item-hover-background-color: var(--menu-item-background-color);
    --menu-item-hover-background-image: var(--menu-item-background-image);
    --menu-item-hover-background: var(--menu-item-hover-background-color) var(--menu-item-hover-background-image);
    --menu-item-hover-margin: var(--menu-item-margin);
    --menu-item-hover-padding: var(--menu-item-padding);
    --menu-item-hover-color: var(--standard-100);
    --menu-item-hover-border: var(--menu-item-border);
    --menu-item-hover-box-shadow: var(--menu-item-box-shadow);
    --menu-item-hover-border-radius: var(--menu-item-border-radius);
    --menu-item-active-background-color: var(--menu-item-active-background-color);
    --menu-item-active-background-image: var(--menu-item-active-background-image);
    --menu-item-active-font-weight: var(--bold);
    --menu-item-active-background: var(--menu-item-background);
    --menu-item-active-margin: var(--menu-item-margin);
    --menu-item-active-padding: var(--menu-item-padding);
    --menu-item-active-color: var(--primary-text-color);
    --menu-item-active-border: var(--menu-item-border);
    --menu-item-active-box-shadow: var(--menu-item-box-shadow);
    --menu-item-active-border-radius: var(--menu-item-border-radius);
  }
  html.dark {
    --menu-item-color: var(--standard-30);
    --menu-item-hover-color: var(--standard-100);
    --menu-item-active-color: var(--primary-text-color);
  }
}

/* src/primitives/menu/css/theme/content/icon-variables.css */
@layer menu.theme.content.icon {
  :host {
    --menu-icon-margin: var(--relative-6px);
  }
}

/* src/primitives/menu/css/theme/content/badge-variables.css */
@layer menu.theme.content.badge {
  :host {
    --menu-badge-margin: var(--relative-6px);
  }
}

/* src/primitives/menu/css/theme/types/selection-variables.css */
@layer menu.theme.type.selection {
  :host {
    --menu-selection-gap: 6px;
    --menu-selection-item-padding: 7px 6px;
    --menu-selection-item-border-radius: var(--border-radius);
    --menu-selection-item-color: var(--standard-30);
    --menu-selection-item-hover-padding: var(--menu-selection-item-padding);
    --menu-selection-item-hover-background: var(--standard-10);
    --menu-selection-item-hover-color: #013A4F;
    --menu-selection-item-hover-box-shadow: none;
    --menu-selection-item-active-padding: var(--menu-selection-item-padding);
    --menu-selection-item-active-background: #D0EBF3;
    --menu-selection-item-active-color: var(--primary-text-color);
    --menu-selection-item-active-box-shadow: 0px 1px 6px rgb(85 147 167 / 77%) inset;
  }
  @container style(--dark-mode: true) {
    :host {
      --menu-selection-item-hover-background: transparent;
      --menu-selection-item-hover-color: var(--standard-90);
      --menu-selection-item-active-background: #35B7F1;
      --menu-selection-item-active-color: var(--black-90);
      --menu-selection-item-active-box-shadow: 0px 0px 10px rgb(0 92 165) inset;
    }
  }
}

/* src/primitives/menu/css/theme/types/sliding-variables.css */
@layer menu.theme.type.sliding {
  :host {
    --menu-sliding-gap: var(--2px);
    --menu-sliding-padding: var(--3px);
    --menu-sliding-border-radius: var(--border-radius);
    --menu-sliding-background: var(--standard-solid-5);
    --menu-sliding-border: var(--internal-border);
    --menu-sliding-item-padding: var(--6px) var(--10px);
    --menu-sliding-item-color: var(--standard-40);
    --menu-sliding-item-hover-color: var(--standard-80);
    --menu-sliding-item-active-color: var(--standard-100);
    --menu-sliding-indicator-background: var(--inverted-100);
    --menu-sliding-indicator-border-radius: var(--border-radius-xs);
    --menu-sliding-indicator-shadow: var(--subtle-shadow);
    --menu-sliding-indicator-transition: var(--transition);
  }
  @container style(--dark-mode: true) {
    :host {
      --menu-sliding-indicator-background: var(--standard-solid-15);
      --menu-sliding-item-active-color: var(--standard-100);
    }
  }
}

/* src/primitives/menu/css/theme/variations/evenly-spaced-variables.css */
@layer menu.theme.variations.evenlySpaced {
  :host {
    --menu-evenly-spaced-item-text-align: center;
  }
}

/* src/primitives/menu/css/theme/variations/vertical-variables.css */
@layer menu.theme.variations.vertical {
  :host {
    --menu-vertical-align-items: stretch;
    --menu-vertical-text-align: left;
  }
}

/* src/primitives/menu/css/theme/variations/inset-variables.css */
@layer menu.theme.variations.inset {
  :host {
    --menu-inset-padding: 3px 4px;
    --menu-inset-border-radius: var(--border-radius);
    --menu-inset-border: var(--internal-border);
    --menu-inset-background: var(--inverted-15);
  }
}

/* src/primitives/menu/css/theme/menu-theme.css */

/* src/primitives/menu/css/menu.css */
